function InitializeAmiYearDropDowns() {
    // Select the last value in the upper year drop down.
    $('.YearDropDownUpper').each(function (index, obj) {
        if (obj.selectedIndex !== null && obj.options !== null && obj.options.length > 0)
            obj.selectedIndex = obj.options.length - 1;
    });
}
